import { Intent } from '../intent/types';
import { createRequestType } from '../../helpers/requestType';

export const FILL_INTENTS = 'FILL_INTENTS';
interface FillIntentsAction {
  type: typeof FILL_INTENTS;
  payload: [Intent];
}

export const saveIntentActionType = createRequestType('SAVE_INTENT');
interface SaveIntentAction {
  type: typeof saveIntentActionType.request;
  payload: Intent;
}

interface SaveSuccessIntentAction {
  type: typeof saveIntentActionType.success;
  payload: Intent;
}

interface SaveFailureIntentAction {
  type: typeof saveIntentActionType.failure;
  payload: any;
}

export const deleteIntentActionType = createRequestType('DELETE_INTENT');
interface DeleteIntentAction {
  type: typeof deleteIntentActionType.request;
  payload: string;
}

interface DeleteSuccessIntentAction {
  type: typeof deleteIntentActionType.success;
  payload: string;
}

interface DeleteFailureIntentAction {
  type: typeof deleteIntentActionType.failure;
  payload: any;
}

export const buildIntentActionType = 'BUILD_INTENT';
interface BuildIntentAction {
  type: typeof buildIntentActionType;
  payload: string;
}

export type IntentActionTypes =
  | FillIntentsAction
  | SaveIntentAction
  | SaveSuccessIntentAction
  | SaveFailureIntentAction
  | DeleteIntentAction
  | DeleteSuccessIntentAction
  | DeleteFailureIntentAction
  | BuildIntentAction;
